import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DefaultLayout from "../../../../layouts/DefaultLayout";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Button, Card, Col, Row, Typography } from "antd";
import { isEmpty } from "lodash";
import ConfirmationDetails from "../ConfirmationDetails";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripeForm from "../../../../ui/forms/StripeForm";

const STRIPE_CONNECTED_ACCOUNT_KEY = `${process.env.REACT_APP_STRIPE_CONNECTED_ACCOUNT_ID}`;
const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;
const promise = loadStripe(STRIPE_KEY, {
	stripeAccount: STRIPE_CONNECTED_ACCOUNT_KEY,
});
/**
 * Asks for user confirmation for a given quote.
 */
@inject("context")
@withRouter
@observer
class QuotingConfirm extends Component {
	state = {
		showCard: false,
	};

	clickShowCard = () => {
		/**		const { insuranceQuotingService } = this.props.context;
		insuranceQuotingService.savePerson();

*/
		this.setState((state) => ({
			showCard: !state.showCard,
		}));
	};

	render() {
		const { insuranceQuotingService } = this.props.context;

		const { clientData } = insuranceQuotingService;
		const selectedQuote = insuranceQuotingService.selectedQuoteToProceed;

		const { showCard } = this.state;

		const quoteForPayment = {
			...selectedQuote,
			stripePaymentPurpose: "QUOTE",
		};

		if (isEmpty(clientData) && isEmpty(selectedQuote)) {
			return <Redirect to="/" />;
		}

		return (
			<DefaultLayout>
				<Row>
					<Col xs={24}>
						<Card title={<h1>Confirmation</h1>}>
							<Row>
								<Col xs={24} />
							</Row>
							<Row>
								<Col xs={24}>
									<ConfirmationDetails
										clientDataTitle={
											<Typography.Title level={4}>
												Your details
											</Typography.Title>
										}
										insuranceDataTitle={
											<Typography.Title level={4}>Your quote</Typography.Title>
										}
										clientData={clientData}
										insuranceData={selectedQuote}
									/>
									<Row>
										<Col
											xs={24}
											className="d-flex"
											style={{ marginTop: "2rem" }}
										>
											<Button className="mr-auto">
												<Link to="/results">{"<<"} Back</Link>
											</Button>
											{!showCard && (
												<Button
													className="ml-auto"
													type="primary"
													onClick={this.clickShowCard}
												>
													Confirm
												</Button>
											)}
										</Col>
									</Row>
									<Row>
										<Col
											xs={24}
											className="d-flex"
											style={{
												marginTop: "1rem",
												justifyContent: "center",
											}}
										>
											{showCard && (
												<Elements stripe={promise}>
													<StripeForm
														quoteForPayment={quoteForPayment}
														hidePostalCode={true}
													/>
												</Elements>
											)}
										</Col>
									</Row>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}
}

export default QuotingConfirm;
